import { useState } from 'react'
import { useToggle } from 'react-use'

import BriefcaseIcon from '~assets/icons/illustrations/briefcase.svg'
import Button from '~elements/Button'
import { DealFragment } from '~generated/operations'
import Arrow from '~lib/ui-kit/Arrow'
import Col from '~lib/ui-kit/Col'
import Row from '~lib/ui-kit/Row'
import Space from '~lib/ui-kit/Space'
import AttachDealsModal from '~modules/deals/containers/AttachDealsModal'
import RevenueImpact from '~modules/feedbackTool/elements/RevenueImpact'

interface FeedbackPostRevenueImpactProps {
  deals: DealFragment[]
  onDealsChange: (deals: DealFragment[]) => void
  className?: string
  readOnly?: boolean
}

function FeedbackPostRevenueImpact({ deals = [], onDealsChange, className, readOnly }: FeedbackPostRevenueImpactProps) {
  const [isRevenueImpactOpened, toggleIsRevenueImpactOpened] = useToggle(true)
  const [isDealsModalOpened, setIsDealsModalOpened] = useState(false)

  const handleOpenDealsModal = () => {
    setIsDealsModalOpened(true)
  }

  const handleCloseDealsModal = () => {
    setIsDealsModalOpened(false)
  }

  return (
    <>
      <div className={className}>
        <Row align="center" justify="space-between" className="mb-2">
          <Col>
            <Row align="center" gutterX="1">
              <Space align="center" justify="center">
                <BriefcaseIcon />
              </Space>

              <Button
                variant="plain"
                bold
                onClick={toggleIsRevenueImpactOpened}
                endIcon={<Arrow as="span" direction={isRevenueImpactOpened ? 'bottom' : 'right'} />}
              >
                Revenue impact
              </Button>
            </Row>
          </Col>

          {!readOnly && (
            <Col>
              <Button variant="plain" bold onClick={handleOpenDealsModal}>
                Edit deals
              </Button>
            </Col>
          )}
        </Row>

        <RevenueImpact deals={deals} showDeals={isRevenueImpactOpened} onDealsChange={onDealsChange} />
      </div>

      <AttachDealsModal
        opened={isDealsModalOpened}
        deals={deals}
        onAttach={onDealsChange}
        onClose={handleCloseDealsModal}
        readOnly={readOnly}
      />
    </>
  )
}

export default FeedbackPostRevenueImpact
